import $ from 'jquery';

$(() => {
    const svgs = [...document.getElementsByClassName('svg')];
    svgs.forEach((element) => {
        let $element = $(element);
        let imgID = $element.attr('id');
        let imgClass = $element.attr('class');
        let imgURL = $element.attr('src');

        $.get(imgURL, (data) => {
            let $svg = $(data).find('svg');
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }
            $svg = $svg.removeAttr('xmlns:a');
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', `0 0 ${$svg.attr('height')} ${$svg.attr('width')}`);
            }
            $element.replaceWith($svg);
        }, 'xml');
    });
});
